var { initialBody } = require("./stores/initialState");
const addresses = [
  {
    street: "Calle larga #1212",
    colony: "Centro",
    city: "Chihuahua,Chihuahua",
    zip: "31124",
  },
  {
    street: "Calle corta #1212",
    colony: "Centro",
    city: "Jurez,Chihuahua",
    zip: "31124",
  },
  {
    street: "Calle mediana #1212",
    colony: "Centro",
    city: "Juarez,Chihuahua",
    zip: "31124",
  },
  {
    street: "Calle algodon #1212",
    colony: "Centro",
    city: "Meoqui,Chihuahua",
    zip: "31124",
  }
];
const users = [
  {
    id: 1,
    name: {
      title: "M.I.D",
      full: "José López Pérez"
    },
    job_title: "Coordinador de ventas",
    institution: "Universidad Autónoma de Chihuahua",
    department: "depto",
    email: "joselopez@hotmail.com",
    temp_profile: 'false',
    user: "joselopez",
    needs_approval: false,
    read: true,
    reply: true
  },
  {
    id: 2,
    name: {
      title: "El portador",
      full: "Frodo Baggings"
    },
    job_title: "Cargar el anillo",
    institution: "La comunidad del anillo",
    email: "frodobolson@bagend.com",
    temp_profile: 'true',
    department: "tesoro",
    needs_approval: true,
    read: false,
    reply: false
  },
  {
    id: 3,
    name: {
      title: "QBP",
      full: "Walter White Smith",
      short: "Walt W"
    },
    job_title: "Profesor de quimica",
    institution: "Supervisor pollos hermanos",
    email: "walterwithe@bluemeth.com",
    temp_profile: 'false',
    user: "walterwithe",
    needs_approval: true,
    read: true,
    reply: false
  },
  {
    id: 4,
    name: {
      title: "DR",
      full: "Hugo Strange"
    },
    job_title: "Jefe de psiquiatría",
    institution: "Arkham",
    email: "hugo@arkham.com",
    temp_profile: 'true',
    needs_approval: false,
    read: false,
    reply: true
  },
  {
    id: 5,
    name: {
      title: "Replicant",
      full: "Rick Deckard"
    },
    job_title: "Policía",
    institution: "Departamento de policía de los Ángeles",
    email: "deckard@runner.com",
    temp_profile: 'false',
    needs_approval: true,
    read: true,
    reply: true
  },
  {
    id: 6,
    name: {
      title: "The Witcher",
      full: "Geralt of Rivia"
    },
    job_title: "Maestro witcher",
    institution: "Escuela del lobo",
    email: "gerald@roach.com",
    temp_profile: 'true',
    needs_approval: false,
    read: false,
    reply: false
  },
  {
    id: 7,
    name: {
      title: "Envoy",
      full: "Takeshi Kovacs"
    },
    job_title: "Special forces",
    institution: "Global order",
    email: "kvaks@sleeve.com",
    temp_profile: 'false',
    needs_approval: true,
    read: true,
    reply: false
  },
  {
    id: 8,
    name: {
      title: "PHD",
      full: "Marie Curie"
    },
    job_title: "Catedrática de química",
    institution: "Universidad de París",
    email: "curie@rads.com",
    temp_profile: 'true',
    needs_approval: false,
    read: false,
    reply: true
  },
  {
    id: 9,
    name: {
      title: "DR",
      full: "Harleen Frances Quinzel"
    },
    job_title: "Psiquiatría médica",
    institution: "Arkham",
    email: "hquinn@arkham.com",
    temp_profile: 'false',
    needs_approval: true,
    read: false,
    reply: true
  },
  {
    id: 10,
    name: {
      title: "M.I.D.",
      full: "Miguel Ángel López Santillán"
    },
    job_title: "Coordinador General de Tecnologías de Información",
    institution: "Universidad Autónoma de Chihuahua",
    email: "miguel@uach.mx",
    temp_profile: 'false',
    needs_approval: false,
    read: true,
    reply: true
  },
  {
    id: 11,
    name: {
      title: "M.F.",
      full: "Manuel Alfonso Palicio Guevara"
    },
    job_title: "Coordinador General de Tecnologías de Información",
    institution: "Universidad Autónoma de Chihuahua",
    email: "manuel@uach.mx",
    temp_profile: 'false',
    needs_approval: true,
    read: false,
    reply: false
  }
];
const login_user = users.pop();
const emptyUser = {
  name: {
    title: "",
    full: ""
  },
  job_title: "",
  institution: "",
  email: ""
};
const newDoc = () => {
  return {
    date: new Date().toISOString().slice(0, 10),
    folio: "",
    to: emptyUser,
    from: login_user,
    body: initialBody,
    address: addresses[0],
    created_by: login_user
  };
};
const getRandom = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const randomUser = () => {
  return users[getRandom(0, users.length - 1)];
};
const docs = [
  {
    id: 1,
    subject: "asuntillo",
    date: "1999-12-11",
    folio: "ADS/756/H67",
    to: randomUser().name.full,
    from: randomUser().name.full,
    body: initialBody,
    created_by: randomUser().name.full,
    sent: false,
    files: [],
    extract: "este es un resumen 1",
    needs_review: []
  },
  {
    id: 2,
    subject: "asuntillo 2",
    date: "1990-11-12",
    folio: "DFG/285/Y56",
    to: randomUser().name.full,
    from: randomUser().name.full,
    body: initialBody,
    created_by: randomUser().name.full,
    sent: false,
    readDetail: [],
    files: [],
    extract: "este es un resumen 2",
    needs_review: []
  },
  {
    id: 3,
    date: "1991-10-13",
    folio: "RTH/552/R51",
    to: randomUser().name.full,
    from: randomUser().name.full,
    body: initialBody,
    created_by: randomUser().name.full,
    sent: true,
    readDetail: [{0:{copy:false, read:false }},{1:{copy:false, read:false }}],
    files: [],
    extract: "este es un resumen 3",
    needs_review: []
  },
  {
    id: 4,
    date: "1992-09-14",
    folio: "DVU/104/A34",
    to: randomUser().name.full,
    from: randomUser().name.full,
    body: initialBody,
    created_by: randomUser().name.full,
    sent: false,
    readDetail: [],
    files: [],
    extract: "este es un resumen 3",
    needs_review: []
  }
];
const user_groups = [
  { short_name: "First group", long_name: "Long desc of the 1 group", id: 1, notices: 0 },
  { short_name: "second group", long_name: "Long desc of the 2 group", id: 2, notices: 1 },
  { short_name: "third group", long_name: "Long desc of the 3 group", id: 3, notices: 1 },
  { short_name: "fourth group", long_name: "Long desc of the 4 group", id: 4, notices: 0 }
];
const slogan = [
  {
    id: 1,
    date: "1999-12-11",
    title: '"Luchar para lograr, lograr para dar"',
  }
];

const revision_notes = [
  {id: 1, note: "Please change the subject", document_id: 1, status:"Pendiente"},
  {id: 2, note: "Please change the second paragraph", document_id: 1, status:"Atendido"}
];

const notices_attributes = [
  {id:1,
  from_id:2,
  note:'asdf',
  notice_users_attributes:[{to:{id:23,email: "hugo@arkham.com"}}]}];

const notice_user_list = [{to:{id:23,email: "hugo@arkham.com"}}];

const devices = [
  {"device_id":918, "device":"browser", "expires":"2019-05-16T17:50:32.000Z", "active":true},
  {"device_id":917, "device":"browser", "expires":"2019-05-16T17:50:32.000Z", "active":false}
];

const listPermissions = [
  {
    id: 1,
    from: 'Sergio Alejandro Luna Flores',
    date: '10/06/2020 - 10:27',
    to: 'César Eduardo Ortiz Palomino',
    type: 'Crear oficios',
    action: 'agregado'
  },
  {
    id: 2,
    from: 'Dulce Rivas Porras',
    date: '15/06/2020 - 09:20',
    to: 'César Eduardo Ortiz Palomino',
    type: 'Otorgar permisos',
    action: 'quitado'
  },
  {
    id: 3,
    from: 'Alejandra Navarro Benítez',
    date: '05/06/2020 - 8:17',
    to: 'César Eduardo Ortiz Palomino',
    type: 'Modificar logo y lema',
    action: 'agregado'
  },
  {
    id: 4,
    from: 'Liliana Lerma García',
    date: '11/06/2020 - 02:10',
    to: 'César Eduardo Ortiz Palomino',
    type: 'Modificar fecha del oficio',
    action: 'quitado'
  }
];

const manuals = [
  {
    "name": "1.Lector",
    "desc": "Usuario que únicamente tiene acceso a leer oficios.",
    "url": "https://drive.google.com/file/d/1DMcGrhb9Q068XqCOIE95aO-7L7jxv90z/view?usp=sharing",
  },
  {
    "name": "2.Delegar y autorizar oficios",
    "desc": "Usuario que puede delegar a una persona para que pueda redactar oficios y revisarlos.",
    "url": "https://drive.google.com/file/d/1CjKb7UfUKCw9fHXAi4IDEaqbyCZ1d4hD/view?usp=sharing",
  },
  {
    "name": "3.Cambiar título y puesto",
    "desc": "Completar o actualizar los datos del perfil del usuario.",
    "url": "https://drive.google.com/file/d/1kJ_Q-6Uncf6Rn4REIkPWXOgizf5yHxNX/view?usp=sharing",
  },
  {
    "name": "4.Crear y firmar un oficio",
    "desc": "Redactar un oficio y firmarlo con el nombre del emisor.",
    "url": "https://drive.google.com/file/d/1S6WrWQf7InHtfPYpvVrUN2D20cKzEpZ6/view?usp=sharing",
  },
  {
    "name": "5.Crear grupos de usuarios",
    "desc": "Configurar grupos de usuarios para enviar oficios a un grupo de destinatarios seleccionados.",
    "url": "https://drive.google.com/file/d/1JXxMAkW3oRXaypEw8JRv9R-vI_-Kfl4g/view?usp=sharing",
  },
  {
    "name": "6.Crear oficio como delegado",
    "desc": "El usuario puede redactar el oficio a nombre de una tercera persona.",
    "url": "https://drive.google.com/file/d/1ZWuwqNSMq7n-s53QZLUsqNAzLLp1KcQ5/view?usp=sharing",
  },
  {
    "name": "7.Delegar usuario para redactar y filtrar oficios",
    "desc": "El usuario puede delegar a una persona para que pueda filtrar los oficios y corroborar el destinatario o reenviarlo a instancias correspondientes.",
    "url": "https://drive.google.com/file/d/1qGJVlzn4ygbjJNo7C4aJAd89pUs9FbFt/view?usp=sharing",
  },
  {
    "name": "8.Otorgar modulos permisos",
    "desc": "El usuario puede dar acceso a otra persona para que pueda firmar oficios, quien a su vez podrá dar a terceros los mismos permisos.",
    "url": "https://drive.google.com/file/d/10wom_Zylf51Pznjq7tbP4FAEWMfIhQfN/view?usp=sharing",
  },
  {
    "name": "9.Otorgar permiso para firmar oficio",
    "desc": "El usuario puede otorgar permiso para que una persona pueda redactar y firmar oficios a su nombre con la opción de revisarlos antes de que se envíen.",
    "url": "https://drive.google.com/file/d/1ywJq72evo0aONOIsTNBQB1sTErEtEwbv/view?usp=sharing",
  },
  {
    "name": "10.Filtro",
    "desc": "Usuario que revisa los oficios redactados y firmados por un tercero.",
    "url": "https://drive.google.com/file/d/1N-UfLcMmcA8ewtf6sao3_oiDMbGJftQj/view?usp=sharing",
  },
  {
    "name": "11.Oficios enviados a revisión y a firma",
    "desc": "Usuario que necesita la revisión de un oficio para poder enviarlo y que solicita la firma de un tercero.",
    "url": "https://drive.google.com/file/d/1MjyP3U6WshfeXsX3ACmohUmbOx-tDZDB/view?usp=sharing",
  },
  {
    "name": "Video 1",
    "desc": "Otorgar permiso para firmar oficio",
    "url": "https://drive.google.com/file/d/1WKqkBrfHw8WKpcZa9yEJK7q-FDiiVWZY/view",
  },
  {
    "name": "Video 2",
    "desc": "Delegar usuario para redactar oficios",
    "url": "https://drive.google.com/file/d/138twAITBJ4bJP-ygirD6hCcYe_vo1dWe/view",
  },
  {
    "name": "Video 3",
    "desc": "Crear oficio como delegado",
    "url": "https://drive.google.com/file/d/163FlI6s8oy_zPzP2rc_EKQJiPuLMgeyI/view",
  },
  {
    "name": "Video 4",
    "desc": "Delegar y autorizar oficios",
    "url": "https://drive.google.com/file/d/1TOe1kvaMJ3hsci9cD-4Thu91lnZSDGcP/view",
  },
  {
    "name": "Video 5",
    "desc": "Crear y firmar un oficio",
    "url": "https://drive.google.com/file/d/1gyRN8dkesw61bITDZxj2hg24Kr9JvG0t/view",
  },
]

const improvements = [
  {
      "title": "Notificaciones",
      "content": [
        "Nueva sección de notificaciones para  actualizaciones y nuevas funcionalidades en la plataforma.",
      ]
  },
  {
      "title": "Reporte de oficios enviados y recibidos",
      "content": [
        "En la sección de oficios enviados y recibidos se puede descargar un reporte de los mismos, seleccionando el icono de descarga en la parte superior derecha.",
      ]
  },
  {
      "title": "Modificación en estilos",
      "content": [
        'Actualización en el estilo de indicadores de avisos para mejorar su visibilidad.',
      ]
  },
]

module.exports = () => {
  return {
    users: users,
    login_user: login_user,
    docs: docs,
    addresses: addresses,
    new_doc: newDoc(),
    user_groups: user_groups,
    revision_notes: revision_notes,
    notices_attributes: notices_attributes,
    notice_user_list: notice_user_list,
    devices: devices,
    slogan: slogan,
    listPermissions: listPermissions,
    manuals: manuals,
    improvements: improvements
  };
};



// WEBPACK FOOTER //
// ./src/db.js